/* eslint-disable import/no-cycle */
import {decorate, observable} from 'mobx';
import {Api} from '../middleware/api';
import {EntityStore} from './entityStore';
import {OperationPhase} from '../models/operationPhase';

export class OperationPhaseStore extends EntityStore {
  operationPhases = [];

  constructor(rootStore) {
    super(rootStore, 'operationPhases', Api.operationPhases, OperationPhase);
  }

  loadByOperation(operationId) {
    return this.loadAll({params: {operationId}});
  }

  getByOperationId(operationId) {
    return this.operationPhases.filter((ph) => ph.operationId === operationId);
  }

  getActiveByOperationIdAndPhaseId(operationId, phaseId) {
    return this.operationPhases.find((ph) => ph.operationId === operationId && ph.phaseId === phaseId);
  }
}

decorate(OperationPhaseStore, {
  operationPhases: observable,
});
